"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScalesByBatteryId = exports.extractResults = exports.expandscreeners = void 0;

var _utils = require("./utils");

var ors = _interopRequireWildcard(require("./ors"));

var pssDeprecated = _interopRequireWildcard(require("./pss-deprecated"));

var pss4 = _interopRequireWildcard(require("./pss4"));

var pss4rtw = _interopRequireWildcard(require("./pss4rtw"));

var stress = _interopRequireWildcard(require("./stress"));

var stressStudents = _interopRequireWildcard(require("./stress-students"));

var personalisation = _interopRequireWildcard(require("./personalisation"));

var pss10 = _interopRequireWildcard(require("./pss10"));

var psycap = _interopRequireWildcard(require("./psycap"));

var roiDayslide = _interopRequireWildcard(require("./roi-hpq-3-dayslide"));

var roiPointslide = _interopRequireWildcard(require("./roi-hpq-3-pointslide"));

var roi = _interopRequireWildcard(require("./roi-hpq-3"));

var roi4Dayslide = _interopRequireWildcard(require("./roi-hpq-4-dayslide"));

var who5 = _interopRequireWildcard(require("./who5"));

var who5rtw = _interopRequireWildcard(require("./who5rtw"));

var who5rtwus = _interopRequireWildcard(require("./who5rtwus"));

var wq5 = _interopRequireWildcard(require("./workplacequestionnaire5"));

var phq9 = _interopRequireWildcard(require("./phq9"));

var gad7 = _interopRequireWildcard(require("./gad7"));

var workability = _interopRequireWildcard(require("./workability"));

var sickAbsense = _interopRequireWildcard(require("./sickAbsense"));

var hrqol = _interopRequireWildcard(require("./HRQoL"));

var economicValue = _interopRequireWildcard(require("./ecoEval"));

var economicValueUS = _interopRequireWildcard(require("./ecoEval-us"));

var rtwDemographic = _interopRequireWildcard(require("./rtw-demographics"));

var clientSatisfactionQ8 = _interopRequireWildcard(require("./clientSatisfactionQuestionnaire-8"));

var helpful = _interopRequireWildcard(require("./helpful"));

var rtwPreScreener = _interopRequireWildcard(require("./rtw-pre-screener"));

var rtwFeedback = _interopRequireWildcard(require("./rtw-post-feedback"));

var progress = _interopRequireWildcard(require("./progress"));

var rtwUsOnboarding = _interopRequireWildcard(require("./rtw-us-onboarding"));

var rtwUsFeedback = _interopRequireWildcard(require("./rtw-us-post-feedback"));

var medibankWho5 = _interopRequireWildcard(require("./medibankWho5"));

var medibankStress = _interopRequireWildcard(require("./medibankStress"));

var medibankPersonalisation = _interopRequireWildcard(require("./personalisation-medibank"));

var allianzWho5 = _interopRequireWildcard(require("./allianzWho5"));

var allianzStress = _interopRequireWildcard(require("./allianzStress"));

var allianzPersonalisation = _interopRequireWildcard(require("./personalisation-allianz"));

var allianzProgress = _interopRequireWildcard(require("./allianzProgress"));

var medibankProgress = _interopRequireWildcard(require("./medibankProgress"));

var medibankProgressV1 = _interopRequireWildcard(require("./medibankProgress-v1"));

var medibankStressOnboarding = _interopRequireWildcard(require("./medibankStressOnboarding"));

var medibankStressV1 = _interopRequireWildcard(require("./medibankStress-v1"));

var medibankStressV2 = _interopRequireWildcard(require("./medibankStress-v2"));

var _batteryModules;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var batteryModules = (_batteryModules = {}, _defineProperty(_batteryModules, _utils.screeners.ORS, ors), _defineProperty(_batteryModules, _utils.screeners.PSS_DEPRECATED, pssDeprecated), _defineProperty(_batteryModules, _utils.screeners.PSS4, pss4), _defineProperty(_batteryModules, _utils.screeners.PSS4RTW, pss4rtw), _defineProperty(_batteryModules, _utils.screeners.PSS10, pss10), _defineProperty(_batteryModules, _utils.screeners.PSYCAP, psycap), _defineProperty(_batteryModules, _utils.screeners.ROI_HPQ_3_DAYSLIDE, roiDayslide), _defineProperty(_batteryModules, _utils.screeners.ROI_HPQ_3_POINTSLIDE, roiPointslide), _defineProperty(_batteryModules, _utils.screeners.ROI_HPQ_3, roi), _defineProperty(_batteryModules, _utils.screeners.ROI_HPQ_4_DAYSLIDE, roi4Dayslide), _defineProperty(_batteryModules, _utils.screeners.WHO5, who5), _defineProperty(_batteryModules, _utils.screeners.WHO5RTW, who5rtw), _defineProperty(_batteryModules, _utils.screeners.WHO5RTWUS, who5rtwus), _defineProperty(_batteryModules, _utils.screeners.workplaceQuestionnaire5, wq5), _defineProperty(_batteryModules, _utils.screeners.STRESS, stress), _defineProperty(_batteryModules, _utils.screeners.STRESS_STUDENTS, stressStudents), _defineProperty(_batteryModules, _utils.screeners.PERSONALISATION, personalisation), _defineProperty(_batteryModules, _utils.screeners.PHQ9, phq9), _defineProperty(_batteryModules, _utils.screeners.GAD7, gad7), _defineProperty(_batteryModules, _utils.screeners.WRKBTY, workability), _defineProperty(_batteryModules, _utils.screeners.SICK, sickAbsense), _defineProperty(_batteryModules, _utils.screeners.HRQOL, hrqol), _defineProperty(_batteryModules, _utils.screeners.ECOVAL, economicValue), _defineProperty(_batteryModules, _utils.screeners.ECOVALUS, economicValueUS), _defineProperty(_batteryModules, _utils.screeners.RTWDEMOG, rtwDemographic), _defineProperty(_batteryModules, _utils.screeners.CSQ8, clientSatisfactionQ8), _defineProperty(_batteryModules, _utils.screeners.HELPFUL, helpful), _defineProperty(_batteryModules, _utils.screeners.RTW_PRE_SCREENER, rtwPreScreener), _defineProperty(_batteryModules, _utils.screeners.RTW_FEEDBACK, rtwFeedback), _defineProperty(_batteryModules, _utils.screeners.PROGRESS, progress), _defineProperty(_batteryModules, _utils.screeners.RTW_US_ONBOARDING, rtwUsOnboarding), _defineProperty(_batteryModules, _utils.screeners.RTW_US_FEEDBACK, rtwUsFeedback), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_STRESS, medibankStress), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_WHO5, medibankWho5), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_PERSONALISATION, medibankPersonalisation), _defineProperty(_batteryModules, _utils.screeners.ALLIANZ_STRESS, allianzStress), _defineProperty(_batteryModules, _utils.screeners.ALLIANZ_WHO5, allianzWho5), _defineProperty(_batteryModules, _utils.screeners.ALLIANZ_PERSONALISATION, allianzPersonalisation), _defineProperty(_batteryModules, _utils.screeners.ALLIANZ_PROGRESS, allianzProgress), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_PROGRESS, medibankProgress), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_PROGRESS_V1, medibankProgressV1), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_STRESS_ONBOARDING, medibankStressOnboarding), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_STRESS_V1, medibankStressV1), _defineProperty(_batteryModules, _utils.screeners.MEDIBANK_STRESS_V2, medibankStressV2), _batteryModules);

var expandscreeners = function expandscreeners(questions) {
  var res = [];

  for (var i = 0; i < questions.length; i++) {
    if (batteryModules[questions[i]]) {
      res.push.apply(res, batteryModules[questions[i]].questions);
    } else {
      res.push(questions[i]);
    }
  }

  return res;
};
/**
	Extract the results for a battery from the users answers
	@param {Array} [questions] The questions that the user answered
	@param {Array} [answers] Users answers
	@param {String} [batteryId] The id of the battery to extract
	@return {Object} result
**/


exports.expandscreeners = expandscreeners;

var extractResults = function extractResults(questions, answers, batteryId) {
  var batteryAnswers = (0, _utils.filterAnswers)(questions, answers, batteryId);
  return batteryModules[batteryId].getResults(batteryAnswers);
};

exports.extractResults = extractResults;

var getScalesByBatteryId = function getScalesByBatteryId(batteryId) {
  if (batteryModules[batteryId].getScales) {
    return batteryModules[batteryId].getScales();
  } else {
    return null;
  }
};

exports.getScalesByBatteryId = getScalesByBatteryId;